<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <div>
    <v-text-field
      class="not-print-applicant-details-item"
      v-model="input"
      :counter="11"
      :rules="[
        validateRequired,
        validateIsPhoneNumber,
      ]"
      :required="required"
      maxlength="11"
      :disabled="disabled"
    ></v-text-field>
    <span class="print-applicant-details-item">
      {{ input }}
    </span>
  </div>
</template>

<script>
import Vue from "vue";
import InputShortAnswer from "./InputShortAnswer.vue";
import { requireTextIsPhoneNumber } from "../utils/validationUtils";

export default Vue.extend({
  name: "InputPhoneNumber",
  props: {mlLibJson:Object,},
  mixins: [InputShortAnswer],
  methods: {
    validateIsPhoneNumber(input) {
      let is_valid = !input || requireTextIsPhoneNumber(input);
      if (is_valid) {
        return true;
      } else {
        let message = "半角数字10桁-11桁で入力してください。";
        return message;
      }
    },
  },
});
</script>
